module.exports = __webpack_public_path__ + "static/media/icon_arrow_purple.8e1f50c7.svg";